import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { toggleTicketRow } from "@/modules/commonUnsubmittedTicket";

import img_cross from "@/assets/img/img_cross.png";

import { 
	ITicketTableProps,
	ITicketTableState
} from "@/types/GlobalTypes";
import nary from "@/modules/nary";


//Copied from ShioBallsTable
export default class FiveDTable extends React.Component<ITicketTableProps, ITicketTableState> {
	state = { expandedRows: {} };

	render() {
		const activeGame = this.props.activeGame;
		const langdata = this.props.langdata;

		//Array consts
		const ary5050keys = [
			"big", "small",

			"odd", "even",

			"all-odd", "all-even",

			"all-low", "all-high"
		];

		const ary5050strings = [
			langdata["txt_big"],
			langdata["txt_small"],
			
			langdata["txt_odd"],
			langdata["txt_even"],
			
			langdata["txt_all_odd"],
			langdata["txt_all_even"],
			
			langdata["txt_all_low"],
			langdata["txt_all_high"]
		];

		//The selected tab
		const activeBetGroup = activeGame.activeBetGroup;
		const is5050Group = activeBetGroup && activeBetGroup === "50-50";

		const isColok = activeBetGroup ? activeBetGroup[0] === "c" : false;
		const isSet = activeBetGroup ? activeBetGroup.indexOf("set") >= 0 : false;
		const maximumNumberCount = activeBetGroup ? (isSet ? 5 : Number(activeBetGroup[1])) : false;

		const activeGroupRows = activeBetGroup ? activeGame.groupedUnsubmittedTickets[activeBetGroup] : [];

		//For set derivatives
		const numberRowFunctionNoDeleteButton = (num: number, numIdx: number) =>
			num ? (
				<div key={"nRFNDB_" + numIdx}>
					{assetImg("m30", num + "", "m30_" + num + "_" + numIdx)}
				</div>
			) : (!num && !isColok) ? (
				<div className="empty" key={"nRFNDB_" + numIdx}>
					<img src={img_cross} alt="Not allowed" />
				</div>
			) : <div className="empty" key={"nRFNDB_" + numIdx} />;

		//Done: don't display all the rows -- instead only show 1 group
		//Done: fix insert bet
		//Done: fix number insertion
		//Done: fix undo bet
		//Done: fix recount total
		//Done: review submit bet: ticket insertion
		//Done: review submit bet: fetchPostData
		//Done: disable used number for Colok on Games\m30
		const not5050Component = (
					activeGroupRows.map((ticket, ticketIdx) => {
						if (!ticket)
							return null;

						const hasEmptyGuess = ticket.numbers.filter(item => item !== null).length === 0;
						const numberArray = ticket.numbers.slice(0);

						const isRowActive = activeGame.activeUnsubmittedTicketRow === ticketIdx;

						let numberArrayCopy: number[][];
						if (isSet) {
							numberArrayCopy = [
								numberArray.slice(1),
								numberArray.slice(2),
								numberArray.slice(3),
								numberArray.slice(4)
							];

							numberArrayCopy[0].unshift(null);
							numberArrayCopy[1].unshift(null, null);
							numberArrayCopy[2].unshift(null, null, null);
							numberArrayCopy[3].unshift(null, null, null, null);
						}

						return [
							<tr key={"MMG_m30_uT_" + ticketIdx + 0}
								className={
									(isRowActive ? "active" : "")
								}
								//to activate row
								{
									...{
										pcode: activeGame.pcode,
										rowidx: ticketIdx
									}
								}
								onClick={this.props.activateUnsubmittedTicketRow}
							>
								<td>
									<div className="ticket-index">
										{ticketIdx + 1}
									</div>
								</td>
								<td className={hasEmptyGuess ? "empty-guess" : ""}>
									{
										ticket.numbers.map((num, numIdx) => num !== null ? (
											<div key={"nRF_" + numIdx} >
												{assetImg("m30", num + "", "m30_" + ticketIdx + "_" + numIdx)}
												<img className="delete"
													src={img_cross}
													{
														...{
															pcode: activeGame.pcode,
															ticketindex: ticketIdx,
															numberindex: numIdx,
															group: activeBetGroup
														}
													}
													onClick={this.props.removeNumberM30}
													alt={"ball " + ticket.numbers}
												/>
											</div>
										) : (
												//Checks for colok and empty number circles
												(5 - numIdx > maximumNumberCount) ?
													(
														//Displays cross emoji for Colok
														!isColok ?
															<div className="empty" key={"nRF_" + numIdx}>
																<img src={img_cross} alt="Not allowed" />
															</div> : null // <div />
													) : <div className="empty" key={"nRF_" + numIdx} />
											)
										)
									}
									{
										//Dropdown button
										isSet ? (
										<div className="toggle-child"
										{
											...{
												index: ticketIdx,
												group: activeBetGroup
											}
										}
											onClick={toggleTicketRow.bind(this)}>
											<i className="fas fa-caret-down" />
										</div>) : ""
									}
								</td>
								<td className={"sl-bet"
									// (hasEmptyBet ? " blink" : "")
								}

									key={activeGame.pcode + "_" + activeBetGroup + "_" + ticketIdx}
									{
										...{
											index: ticketIdx,
											group: activeBetGroup,
											pcode: activeGame.pcode
										}
									}
									onClick={this.props.insertBet}
								>
									<div className="bet-label">
										{ticket.bet}
									</div>

									{/* Remove Bet button */}
									<img className="delete"
										src={img_cross}
										{
											...{
												pcode: activeGame.pcode,
												ticketindex: ticketIdx,
												group: activeBetGroup
											}
										}
										onClick={this.props.removeBet}
										alt={"bet " + ticketIdx}
									/>
								</td>
							</tr>
							,
							...(
								//Set Children
								//no need to use complex interactions
								this.state.expandedRows &&
								this.state.expandedRows[activeBetGroup] &&
								this.state.expandedRows[activeBetGroup][ticketIdx] ? (
									nary(4).map(num =>
										<tr key={"MMG_m30_uT_" + ticketIdx + num}>
											{/* Ticket number column */}
											<td />

											{/* Guess column */}
											<td>
												{
													numberArrayCopy[num - 1].map(numberRowFunctionNoDeleteButton)
												}
											</td>

											{/* Bet column */}
											<td>
												<div className="bet-label">
													{activeGame.groupedUnsubmittedTickets[activeBetGroup][ticketIdx].bet}
												</div>
											</td>
										</tr>
									)
								) : []
							)
						];
					})
		);

		return (
			<div className="table-unsubmitted-tickets"
			{
				...{ betgroup: activeBetGroup, pcode: "m30" }
			}>
				{
					this.props.mobile ? (
						<div className="header">
							{
								((group) => {
									if (!group)
										return null;

									switch (group) {
										case "c5set": return "C5 Set";
										case "5dset": return "5D Set";
										default: break;
									}

									if (group[0] === "c")
										return "Colok " + group[1] + "D";

									if (group[0] === "d")
										return group[1] + "D";

									return null;
								})(activeBetGroup)
							}
						</div>
					) : null
				}

				<div className="scrollable-area">
					<table>
						<thead>
							{
								activeBetGroup ? (
									<tr>
										<td />
										<td>{langdata["txt_guess"]}</td>
										<td>{langdata["txt_bet"]}</td>
									</tr>
								) : null
							}
						</thead>

						<tbody>
							{
								//Not 50-50 Group
								activeBetGroup && !is5050Group ?
									not5050Component : null
							}
							

							{
								//Note: Use bets like old games
								activeBetGroup && is5050Group ?
									ary5050keys.map((item, idx) => {
										const betGroup = "n50";
										const betKey = `${item}+${betGroup}`;

										return (
											<tr key={"MMG_m30_uT_" + idx}

												className={activeGame.activeUnsubmittedTicketRow === idx ? "active" : ""}

												{
													...{
														//to activate row
														pcode: activeGame.pcode,
														rowidx: idx
													}
												}
												onClick={this.props.activateUnsubmittedTicketRow}>

												<td>
													<div className="ticket-index">
														{idx + 1}
													</div>
												</td>

												{/* Guess column */}
												<td>
													{ /* item */ }
													{ary5050strings[idx] }
												</td>

												{/* Bet column */}
												<td className={"sl-bet"}
													key={activeGame.pcode + "_" + item + "_" + idx}

													{
														...{
															bet: item,
															group: betGroup,
															pcode: activeGame.pcode
														}
													}

													onClick={this.props.insertBet}
												>
													<div className="bet-label">
														{
															//Use betting system like old games
															activeGame.bet[betKey] ?
																activeGame.bet[betKey] : 0
														}
													</div>

													{/* Remove Bet button */}
													{
														<img className="delete"
															src={img_cross}
														
															{
																...{
																	pcode: activeGame.pcode,
																	betkey: item + "+n50"
																}
															}
														
															onClick={this.props.removeBet}
															alt={"bet " + idx}
														/>
													}
												</td>
											</tr>
										);
									})
									: null
							}

							{
								//When there is no selected tab

								//Todo: remove colspan on LT and SHB
								!activeBetGroup ?
									<tr key={"MMG_m26_uT_choose"}>
										<td>
											{this.props.langdata["txt_choose_bet_type"]}
										</td>
									</tr>

									//Don't add Add Tickets when it's 50-50
									: is5050Group ? null

									//Empty Unsubmitted Tickets
									: (
										<tr key={"MMG_m26_uT_add"}
											{ ...{pcode: activeGame.pcode}}
											onClick={this.props.addUnsubmittedTicketRow}

											className="add-ticket">
											<td colSpan={3}>
												{this.props.langdata["txt_add_tickets"]}
											</td>
										</tr>
									)
							}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}